import * as React from 'react';

import type {FilterObject} from 'nutshell-core/types';

// @ts-expect-error - imported from .js/.jsx file

import {ArchiveIcon} from 'shells/icon/svg/archive-icon';
import {LegacySetupTableWrapper} from 'shells/table/legacy-setup-table-wrapper';

import {useUndeleteEmailSequenceTemplate} from '../../graphql/hooks/use-undelete-email-sequence-template';
import {getGroupSequenceTemplates} from '../../sender/sender-with-groups/helpers';

import {getEmailSequenceTemplateFilters} from '../email-utils/get-email-sequence-template-filters';

import {ArchivedTemplateTable} from './archived-template-table';
import {useGetEmailTemplateGroups} from './graphql/hooks';

type Props = {
    activeFilters: FilterObject[];
};

export function ArchivedTableWrapper(props: Props) {
    const {undeleteEmailSequenceTemplate} = useUndeleteEmailSequenceTemplate();
    const {creatorIds, onlyArchived, includeShared, search, includeUnsharedFromOthers} =
        getEmailSequenceTemplateFilters(props.activeFilters);

    const queryVariables = {
        creatorIds,
        search,
        onlyArchived,
        includeShared,
        includeUnsharedFromOthers,
    } as const;

    const {groups, uncategorized, isLoading, errorMessage, refetch} =
        useGetEmailTemplateGroups(queryVariables);

    React.useEffect(() => {
        refetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onlyArchived]);

    const templates = getGroupSequenceTemplates(groups)
        .concat(uncategorized)
        .filter((template) => template.deletedTime)
        .filter((template, index, array) => array.findIndex((t) => t.id === template.id) === index);

    return (
        <LegacySetupTableWrapper
            icon={ArchiveIcon}
            title='Archived templates'
            count={templates.length}
        >
            <ArchivedTemplateTable
                templates={templates}
                isLoading={isLoading && !templates.length}
                errorMessage={errorMessage}
                onRestoreTemplate={(templateId: string) =>
                    undeleteEmailSequenceTemplate(templateId).then(refetch)
                }
            />
        </LegacySetupTableWrapper>
    );
}
